import React, { createContext, useContext, ReactNode } from 'react';
import { useNotifications, Notification } from '@hook/use-notifications';
import { useUserProfileContext } from './user_profile';

interface NotificationContextType {
    connected: boolean;
    notifications: Notification[];
    clearNotifications: () => void;
    dismissNotification: (id: string) => void;
    markAllAsRead: () => void;
}

const NotificationContext = createContext<NotificationContextType | null>(null);

interface NotificationProviderProps {
    children: ReactNode;
    apiBaseUrl: string;
}

export const NotificationProvider: React.FC<NotificationProviderProps> = ({
    children,
    apiBaseUrl
}) => {
    const [, userInfo] = useUserProfileContext();
    const userId = userInfo?.id || '';
    const notificationState = useNotifications(userId, apiBaseUrl);

    return (
        <NotificationContext.Provider value={notificationState}>
            {children}
        </NotificationContext.Provider>
    );
};

export const useNotificationContext = () => {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotificationContext must be used within a NotificationProvider');
    }
    return context;
};